import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

const Staff = () => {
  const query = graphql`
    query teamQuery {
      allFile(filter: { relativeDirectory: { eq: "about-us/team" } }) {
        nodes {
          publicURL
          name
        }
      }
      allTeamJson {
        nodes {
          staff {
            Name
            Title
            Image
          }
        }
      }
    }
  `
  const data = useStaticQuery(query)

  return (
    <div className="tabContent tabContent--selected cards">
      <div className="container content columns is-mobile is-multiline is-centered">
        {data.allTeamJson.nodes[0].staff.map((member) => {
          const image = data.allFile.nodes.find((n) => n.name === member.Image).publicURL
          return (
            <div className="article-card column is-3-desktop is-6-tablet is-12-mobile has-text-centered-tablet">
              <img src={image} className="profile-image main" alt="" />

              <div className="has-text-centered-tablet name-label">
                <h4 className="is-marginless">{member.Name}</h4>
                <p>{member.Title}</p>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Staff
